export default `float y=p.y+=.2;
  p.z-=round(p.z);
  float e, s=3.;
  p=.7-abs(p);
  for(int i=0;i++<8;p.z+=5.)
    p=abs(p.x>p.y?p:p.yxz)-.8,
    s*=e=5./min(dot(p,p),.5),
    p=abs(p)*e-6.;
  return e=min(y,length(p.yz)/s);
}`